export const defaultMaxItemNameLength = 50;
export const minimumInputCharSearch = 2;
export const enterKey = 13;
export const backSpaceKey = 8;
